package horcrux.common.api.dtos.types

import arrow.core.Either
import com.benasher44.uuid.Uuid
import com.benasher44.uuid.uuid4
import com.benasher44.uuid.uuidFrom
import horcrux.common.HorcruxEither
import horcrux.common.UuidSerializer
import horcrux.common.ValidatedValueClass
import horcrux.common.configs.DocumentStorageConfigs
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@Serializable
@JvmInline
value class CollectionID(@Serializable(with = UuidSerializer::class) override val value: Uuid) :
    ValidatedValueClass<Uuid, CollectionID> {
    val embeddingStoragePathPrefix: String
        get() = "${DocumentStorageConfigs.EMBEDDING_BASE_PATH}/${betterToString()}"

    companion object {
        val PARAMETER_NAME: ParameterName = ParameterName("collectionID")
        operator fun invoke(collectionID: String): HorcruxEither<CollectionID> = Either.catch {
            CollectionID(uuidFrom(collectionID))
        }

        operator fun invoke(): CollectionID = CollectionID(uuid4())
    }
}
